// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + {"52":"css/account","364":"css/admin","412":"css/video-request","517":"css/embed-recorder","724":"css/video","785":"css/prelogin","906":"css/global"}[chunkId] + ".css";
};